import { NgModule } from '@angular/core';
import { Configuration } from '@ducat-pro-anapi/swag-anapi-v2';

import { ConfigService } from '../../config';

@NgModule({
    providers: [
        {
            provide: Configuration,
            deps: [ConfigService],
            useFactory: (configService: ConfigService) =>
                new Configuration({ basePath: `${configService.apiEndpoint}/lk/v2` }),
        },
    ],
})
export class AnapiModule {}
